// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionCaseStatusUpdate" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionCaseStatus } from "./chat-regression-case-status.enum.gen";

export const ChatRegressionCaseStatusUpdateGenShape = z.strictObject({
  ids: z.array(z.string()),
  status: z.enum(ChatRegressionCaseStatus),
});
